export async function stakeToTowns(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { amount, delegatee, operatorAddress, beneficiary, signer } = fnArgs;
    if (!spaceDapp?.townsToken || !spaceDapp.config.addresses.utils.towns) {
        throw new Error('spaceDapp.townsToken is required for stakeToTowns operation.');
    }
    const townsAddress = spaceDapp.config.addresses.utils.towns;
    const rewardsAddress = spaceDapp.config.addresses.baseRegistry;
    if (!townsAddress || !rewardsAddress) {
        throw new Error('Towns and Rewards addresses are required for stakeToTowns operation.');
    }
    // Get the space to validate it exists
    const space = spaceDapp.getSpace(delegatee);
    if (!space) {
        throw new Error(`Space with spaceId "${delegatee}" is not found.`);
    }
    const toAddress = [];
    const callData = [];
    // Only include delegation operation if operatorAddress is provided
    if (operatorAddress) {
        const addSpaceDelegationCallData = spaceDapp.baseRegistry.spaceDelegation.interface.encodeFunctionData('addSpaceDelegation', [delegatee, operatorAddress]);
        toAddress.push(rewardsAddress);
        callData.push(addSpaceDelegationCallData);
    }
    const toApproveCallData = spaceDapp.townsToken?.interface.encodeFunctionData('approve', [
        rewardsAddress,
        amount,
    ]);
    const toStakeCallData = spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('stake', [
        amount,
        delegatee,
        beneficiary,
    ]);
    toAddress.push(townsAddress, rewardsAddress);
    callData.push(toApproveCallData, toStakeCallData);
    return smartAccount.sendUserOp({
        toAddress,
        callData,
        signer,
        spaceId: delegatee,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
